<template>
  <section class="upload">
    <el-upload
      class="avatar-uploader"
      :action="action"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-button :disabled="!cmap"
               type="success"
               @click="svgUpload"
               class="button">C端地图转换上传</el-button>
  </section>
</template>

<script>
import Axios from 'axios';
import { getPlacesInfo } from '@/api/map';

export default {
  name: 'Upload1',
  data() {
    return {
      file: '',
      imageUrl: '',
      action: 'https://ali-openfaas.aibee.cn/function/deployment-service/floor/upload_img_file',
      cmap: '',
    };
  },
  methods: {
    async initInfo() {
      if (!this.$route.query.floor_id) {
        this.$message('请选择楼层');
        return;
      }
      const { data } = await getPlacesInfo({ place_id: this.$route.query.place_id });
      const floor = data[0].floors.find(e => e.id == this.$route.query.floor_id);
      this.cmap  = floor.floor_cmap;
      if(floor.and_map){
        this.imageUrl = floor.and_map.startsWith('"')? floor.and_map.slice(1, floor.and_map.length - 1): floor.and_map;
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.error_no === 0) {
        this.imageUrl = res.data;
        this.$message({
          type: 'success',
          message: '上传OSS服务成功',
        });
        this.handlePutUrl();
      } else {
        this.$message({
          type: 'fail',
          message: '上传OSS服务失败',
        });
      }
    },
    handlePutUrl() {
      Axios.put('function/deployment-service/floor/and-map-info', {
        floor_id: +this.$route.query.floor_id,
        and_map: this.imageUrl,
      }).then((resp) => {
        this.$message({
          type: resp.data.error_no === 0 ? 'success' : 'fail',
          message: resp.data.error_no === 0 ? '添加成功' : '上传后端失败',
        });
      }).catch(() => {
        this.$message({
          type: 'fail',
          message: '上传后端失败',
        });
      });
    },
    beforeAvatarUpload(file) {
      if (!this.$route.query.floor_id) {
        this.$message('请选择楼层');
        return false;
      }
      const isImage = file.type.includes('image');
      console.log(123231, file);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('请上传图片格式文件!');
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isImage && isLt5M;
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await Axios.post(this.action, formData, { 'Content-type': 'multipart/form-data' });
      this.imageUrl = data.data;
      this.handlePutUrl();
    },
    svgUpload() {
      console.log('svg图片转png上传', this.cmap);
      if (!this.cmap) {
        this.$message('请上传C端地图');
        return;
      }
      const canvas = document.createElement('canvas');
      canvas.width = 4000;
      canvas.height = 4000;
      const ctx = canvas.getContext('2d');
      const image = new Image();
      image.src = this.cmap;
      image.setAttribute('crossOrigin', 'Anonymous');
      image.onload = () => {
        ctx.drawImage(image, 0, 0, 4000, 4000);
        canvas.toBlob((blob) => {
          const file = new File([blob], 'cmap.png', { type: 'image/png' });
          this.uploadFile(file);
        });
      };
    },
  },
  mounted() {
    this.initInfo();
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  margin: 20px 20px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #409EFF;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 20px;
}
.button {
  margin-left: 20px;
}
</style>
